import { useProductPageStore } from '../../contexts/ProductPageStore'
import { fetchListingQualityRuleDefinitions, fetchListingQualityScore } from './fetchListingQuality'
import styles from './listingQuality.module.scss'
import { getScoreBandClass } from './scoreBand'

import { useCallback, useEffect, useRef, useState } from 'react'

import useFeatureFlag from 'Clutch/Hooks/useFeatureFlag'

import Modal from 'Clutch/Components/Modal/ModalWithPortal'

import InternalWidgetDock from 'Clutch/Molecules/InternalWidgetDock'

import Typography from 'Clutch/Atoms/Typography/Typography'

const ListingQualityWrapper = () => {
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)
  const feedbackEnabled = useFeatureFlag('PDP_Show_Fitment_Feedback_Internals')

  const [score, setScore] = useState(null)
  const [ruleDefinitions, setRuleDefinitions] = useState([])
  const [hasFetched, setHasFetched] = useState(false)
  const [showDetail, setShowDetail] = useState(false)
  const modal = useRef(null)

  useEffect(() => {
    if (!feedbackEnabled || !skuVariantNumber || hasFetched) return

    const fetchData = async () => {
      const [scoreResult, ruleDefinitionsResult] = await Promise.all([
        fetchListingQualityScore(skuVariantNumber),
        fetchListingQualityRuleDefinitions(),
      ])
      setScore(scoreResult)
      setRuleDefinitions(ruleDefinitionsResult)
      setHasFetched(true)
    }

    fetchData()
  }, [feedbackEnabled, skuVariantNumber, hasFetched])

  useEffect(() => {
    if (showDetail) modal?.current?.open()
    if (!showDetail) modal?.current?.close()
  }, [showDetail])

  const toggleDetail = useCallback(() => setShowDetail((isShowing) => !isShowing), [])
  const closeDetail = useCallback(() => setShowDetail(false), [])

  const overallScore = score?.overallScore ?? score?.score

  if (!feedbackEnabled || overallScore == null) return false

  const roundedScore = Math.round(overallScore)

  // Deferred past the flag/score early return above so the modal never loads for a reader who
  // will not see it — same pattern as engineFitmentFeedbackWrapper.
  const ListingQualityModalContents = require('./listingQualityModal').default

  return (
    <>
      <InternalWidgetDock>
        <button
          type={'button'}
          className={`${styles.scoreDisplay} ${getScoreBandClass(score.scoreBand)}`}
          onClick={toggleDetail}
          aria-label={`Listing quality score ${roundedScore}${
            score.scoreBand ? `, ${score.scoreBand}` : ''
          }. Open listing quality details.`}
        >
          <Typography size={1} font={'bold'}>
            Listing Quality: {roundedScore}
          </Typography>
        </button>
      </InternalWidgetDock>
      <Modal id={'listingQualityModal'} outsideClick ref={modal} customOnClose={closeDetail}>
        {ListingQualityModalContents && <ListingQualityModalContents score={score} ruleDefinitions={ruleDefinitions} />}
      </Modal>
    </>
  )
}

export default ListingQualityWrapper
